/**
 * Entry de la página `/reportes.html` — Fase 5f.
 *
 * Galería tabular de reportes oficiales. Cualquier piloto autenticado
 * puede verla; el botón "+ Subir reporte" solo aparece a Oficial+.
 * Las filas son no clicables en esta sesión: la página de detalle
 * (`/reporte.html`) entra en una sub-fase posterior.
 */

import { mountReportesList } from './modules/reportes-list/mount.js';

mountReportesList();
